import React from 'react';
import { routeMappings } from '../../constants';
import { withBasicDetails } from '../../base/components/WithBasicDetails';
import BasicTaskListPage from '../../basicTaskList/components/BasicTaskListPage';
import withTaskFlow from '../../taskList/components/WithTaskFlow';
import { RouteParams } from '../../base/components/Routes';
import { StageCompletionPage } from '../../staticPages/components/StageCompletionPage';
const BasicEndPage = React.lazy(() => import('../../basicTaskList/components/BasicEndPage'));

const basicTaskListRoutes: RouteParams[] = [
  {
    path: routeMappings['BASICTASKLIST_END'],
    exact: true,
    component: withBasicDetails(withTaskFlow(BasicEndPage)),
  },
  {
    path: `${routeMappings['BASICTASKLIST']}/:id`,
    exact: true,
    component: withBasicDetails(BasicTaskListPage),
  },
  {
    path: `${routeMappings['TASK_COMPLETION']}`,
    exact: true,
    component: withBasicDetails(StageCompletionPage),
  },
];

export default basicTaskListRoutes;
